import React, { createContext, useContext, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AgentCtx = createContext({});
export const useAgent = () => useContext(AgentCtx);

/**
 * agentFetch — wrapper fetch agent avec credentials:'include' (Sprint Frontend B3)
 *
 * Auth = cookie httpOnly `agent-token` envoyé automatiquement par le navigateur.
 * Plus de header Authorization, plus de localStorage.getItem('agent-token').
 */
export function agentFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
}

export default function AgentLayout({ children, title, headerActions }) {
  const navigate   = useNavigate();
  const location   = useLocation();
  const { status: authStatus, role, logout: authLogout } = useAuth();

  // Garde auth : redirige login si non authentifié ou pas agent
  useEffect(() => {
    if (authStatus === 'loading') return;
    if (authStatus !== 'authenticated' || role !== 'agent') {
      navigate('/agent');
    }
  }, [authStatus, role, navigate]);

  const logout = async () => {
    await authLogout();
    navigate('/agent');
  };

  const isActive = (path) => location.pathname.startsWith(path);

  // Pendant le check auth ou pendant redirect → on n'affiche rien
  if (authStatus === 'loading' || authStatus !== 'authenticated' || role !== 'agent') {
    return null;
  }

  return (
    <AgentCtx.Provider value={{}}>
      <div style={{ minHeight: '100vh', background: '#F5F3F0', fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
        {/* Header */}
        <div style={{
          background: '#FDFCFA', borderBottom: '1px solid #E0DDD8',
          padding: '0 24px', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between', height: 56, position: 'sticky', top: 0, zIndex: 100,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
            <Link to="/agent/clients" style={{ textDecoration: 'none' }}>
              <span style={{ fontWeight: 700, fontSize: 20, color: '#D4724A', letterSpacing: '-0.5px' }}>
                Aidly <span style={{ fontSize: 13, fontWeight: 500, color: '#8A8A8A' }}>Agent</span>
              </span>
            </Link>
            <nav style={{ display: 'flex', gap: 4 }}>
              {[
                { path: '/agent/clients', label: 'Clients' },
                { path: '/agent/leads',   label: 'Leads' },
              ].map(({ path, label }) => (
                <Link key={path} to={path} style={{
                  textDecoration: 'none', padding: '6px 14px', borderRadius: 8, fontSize: 14, fontWeight: 500,
                  background: isActive(path) ? '#FFF0EA' : 'transparent',
                  color: isActive(path) ? '#D4724A' : '#5A5A5A',
                }}>
                  {label}
                </Link>
              ))}
            </nav>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {title && <span style={{ fontSize: 14, color: '#8A8A8A' }}>{title}</span>}
            {headerActions}
            <button onClick={logout} style={{
              padding: '6px 14px', borderRadius: 8, border: '1px solid #E0DDD8',
              background: 'transparent', fontSize: 13, color: '#8A8A8A', cursor: 'pointer',
            }}>
              Déconnexion
            </button>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: 24 }}>
          {children}
        </div>
      </div>
    </AgentCtx.Provider>
  );
}
